import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateActionComponent } from 'app/dialogs/create-action/create-action.component';

import { NotificationsService } from 'app/layout/components/navbar/navbar-notification/notifications.service';
import { _isAuthenticated, _isId, AuthService } from 'app/services/auth.service';
import { ActionService } from 'app/services/models/action.service';

// Interface
interface notification {
  messages: [];
  systemMessages: [];
  system: Boolean;
}

@Component({
  selector: 'app-navbar-notification',
  templateUrl: './navbar-notification.component.html'
})
export class NavbarNotificationComponent implements OnInit {

  public notifications: notification;

  public actions: any[];
  constructor(
    private actionService: ActionService,
    private modalService: NgbModal,
    private authService: AuthService
  ) {
    this.authService.identityCheck()
  }


  async ngOnInit() {
    if (_isAuthenticated) {
      await this.getUserByIdActions(_isId);
    }
  }

  async getUserByIdActions(id) {
    const data = await this.actionService.getUserByIdAction(id);
    this.actions = data;
    console.log(this.actions);
  }

  showActionDetail(id) {
    const action = this.actions.find(p => p.id == id);
    const modal = this.modalService.open(CreateActionComponent, {
      size: 'lg',
      centered: true,
      windowClass: 'modal modal-success'
    })
    modal.componentInstance.data = {
      requestTask: action.requestTask,
      actionId: id
    };
  }
}
